import axios from 'axios';
import { useLayoutEffect } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { getError } from '../utils/errors';
import { NotificationsStore } from '../stores/notifications.store';

export const useBackendErrors = () => {
    const [{ defaultService }] = useDependencies(NotificationsStore);

    useLayoutEffect(() => {
        const interceptorId = axios.interceptors.response.use(
            config => config,
            config => {
                if (!axios.isCancel(config)) {
                    const responseData = config.response?.data;
                    const error = getError({ message: responseData?.detail });

                    defaultService.error({ title: error.name, message: error.message });
                }

                return Promise.reject(config);
            },
        );

        return () => {
            axios.interceptors.response.eject(interceptorId);
        };
    }, [defaultService]);
};
